module.exports = __webpack_public_path__ + "static/media/membership2027-child.3580e159.png";